import { ALLOWED_PRICE_FACET } from "@/constants";

export const carouselImageFormatter = (
  skuResourceName = "",
  isNewProduct = false
) => {
  if (skuResourceName) {
    return `//kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2F${
      isNewProduct ? "2New" : "Blank"
    }&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is{PAWEB%2F${skuResourceName}}`;
  }
  return "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
};

export const imageFormatter = skuResourceName => {
  if (skuResourceName) {
    return `https://kohler.scene7.com/is/image/PAWEB/${skuResourceName}`;
  }
  return "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
};

export const colorImageFormatter = colorid => {
  if (colorid) {
    return `https://kohler.scene7.com/is/image/PAWEB/swatch_${colorid}?$SwatchSS$`;
  }
};

export const selectOptions = {
  en: [
    { label: "Sort by", value: "" },
    { label: "Relevance", value: " " },
    { label: "Name A-Z", value: "productHeading_s asc" },
    { label: "Name Z-A", value: "productHeading_s desc" },
  ],
  vn: [
    { label: "Sort by", value: "" },
    { label: "Sự liên quan", value: " " },
    { label: "Tên A-Z", value: "productHeading_s asc" },
    { label: "Tên Z-A", value: "productHeading_s desc" },
  ],
};

export const filterMapping = [
  {
    en: {
      ProductNewProduct: { label: "New", type: "checkbox" },
      SKUColorFinishCode: { label: "color/finish", type: "image" },
      ProductInstallationType: { label: "installation type", type: "list" },
      ProductNumberofHandles: { label: "number of handles", type: "list" },
      ProductProductType: { label: "product type", type: "list" },
      ProductOverallWidthMm: { label: "size - front to back", type: "range" },
      RegionProductCategoryLocal: { label: "category", type: "list" },
      NumberOfHoles: { label: "number of holes", type: "list" },
      ProductMaterial: { label: "material", type: "list" },
      ProductConfiguration: { label: "settings", type: "list" },
      ProductShape: { label: "shape", type: "list" },
      LitersPerFlush: { label: "liters per discharge", type: "list" },
      NightLight: { label: "night light", type: "list" },
      ProductLitersPerMinute: { label: "LITERS PER FLUSH", type: "list" },
      SprayType: { label: "spray type", type: "list" },
      ProductOverallLengthMm: { label: "size - side to side", type: "range" },
      toilet_type: { label: "toilet type", type: "list" },
      HandleStyle: { label: "Handle type", type: "list" },
      TouchlessFaucet: { label: "touchless", type: "list" },
      IntelligentToilet: { label: "intelligent toilet", type: "list" },
      BowlShape: { label: "bowl shape", type: "list" },
      BidetFunctionality: { label: "bidet functionality", type: "list" },
      ProductBrandNameDisplay: { label: "Collection", type: "list" },
    },
    vn: {
      ProductNewProduct: { label: "Sản phẩm mới", type: "checkbox" },
      SKUColorFinishCode: { label: "màu/sơn hoàn thiện", type: "image" },
      ProductInstallationType: { label: "loại lắp đặt", type: "list" },
      ProductNumberofHandles: {
        label: "Số lượng tay cầm",
        type: "list",
      },
      ProductProductType: { label: "Loại sản phẩm", type: "list" },
      ProductOverallWidthMm: {
        label: "Chiều rộng tổng thể (mm)",
        type: "range",
      },
      RegionProductCategoryLocal: { label: "Danh mục", type: "list" },
      NumberOfHoles: { label: "Số lỗ", type: "list" },
      ProductMaterial: { label: "Chất liệu", type: "list" },
      ProductConfiguration: { label: "Cấu hình", type: "list" },
      ProductShape: { label: "Hình dạng", type: "list" },
      LitersPerFlush: { label: "Lít mỗi xả", type: "list" },
      NightLight: { label: "Đèn ban đêm", type: "list" },
      ProductLitersPerMinute: { label: "Lít mỗi phút", type: "list" },
      SprayType: { label: "Loại phun", type: "list" },
      ProductOverallLengthMm: {
        label: "Chiều dài tổng thể (mm)",
        type: "range",
      },
      toilet_type: { label: "Loại bồn cầu", type: "list" },
      HandleStyle: { label: "Kiểu tay cầm", type: "list" },
      TouchlessFaucet: { label: "Vòi không chạm", type: "list" },
      IntelligentToilet: { label: "Bồn cầu thông minh", type: "list" },
      BowlShape: { label: "Hình dạng bồn cầu", type: "list" },
      BidetFunctionality: { label: "Chức năng bidet", type: "list" },
      ProductBrandNameDisplay: { label: "Bộ sưu tập", type: "list" },
    },
  },
];

export const filterImageFormatter = (
  value = "",
  selectedValue = "",
  filterOption = []
) => {
  if (value) {
    return `https://kohler.scene7.com/is/image/PAWEB/${value}?$SwatchSS$`;
  }
  if (selectedValue) {
    const option = filterOption.find(option => option.value === selectedValue);
    if (option) {
      return `https://kohler.scene7.com/is/image/PAWEB/${option.name}?$SwatchSS$`;
    }
  }
  return "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
};

export const staticLabelsPLP = {
  en: {
    showLess: "Show less",
    showMore: "Show more",
    filterby: "Filter By:",
    clearAll: "Clear all",
    category: "Category:",
    showAll: "Show all",
    buttonMDLabel: "Categories & filters",
    colorLabel: "Select Color",
    searchForLabel: "Search results for",
    totalProductLabel: "Search results",
    product: "Products",
    spec: "Spec",
    tech: "Technical Information Downloads",
    template: "Template & Symbol Downloads",
    didYouMean: "Did you mean?",
    selectCategoryLabel: "Select a Category",
    noProductFound:
      "Sorry! No product found in this combination. Please reset the filter and try again.",
    contentType: "Content Type",
    quickView: "Quick View",
    addToCompareLabel: "Add to Compare",
    removeFromCompare: "Remove from Compare",
    removeProduct: "Remove Product",
  },
  vn: {
    showLess: "Rút gọn",
    showMore: "Xem thêm",
    filterby: "Lọc theo:",
    clearAll: "Xóa tất cả",
    category: "Danh mục:",
    showAll: "Hiển thị tất cả",
    buttonMDLabel: "Danh mục & Bộ lọc",
    colorLabel: "Chọn màu",
    searchForLabel: "Kết quả tìm kiếm cho",
    totalProductLabel: "Kết quả tìm kiếm",
    product: "Sản phẩm",
    spec: "Thông số kỹ thuật",
    tech: "Tải xuống thông tin kỹ thuật",
    template: "Tải xuống mẫu và biểu tượng",
    didYouMean: "Ý bạn là?",
    selectCategoryLabel: "Chọn danh mục",
    noProductFound:
      "Xin lỗi! Không tìm thấy sản phẩm nào cho kết hợp này. Vui lòng đặt lại bộ lọc và thử lại.",
    contentType: "Loại nội dung",
    quickView: "Xem nhanh",
    addToCompareLabel: "Thêm vào so sánh",
    removeFromCompare: "Xóa khỏi so sánh",
    removeProduct: "Xóa sản phẩm",
  },
};

export const DEFAULT_IMAGE_LINK =
  "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";

export const formatterHeader = (
  header = "",
  categoryConfig = "",
  category_labels = {}
) => {
  if (categoryConfig) {
    categoryConfig = categoryConfig
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2");
    if (category_labels[categoryConfig]) {
      return category_labels[categoryConfig];
    }
    return categoryConfig
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2");
  }
  if (Array.isArray(header)) {
    return header[header.length - 1].replace(/\+/g, " ");
  }
  return header.replace(/\+/g, " ");
};

export const SHOWALL_LABELS = {
  vn: {
    categoryButton: "Danh mục & Bộ lọc",
    category: "Danh mục",
  },
  en: {
    categoryButton: "Category & Filters",
    category: "Category",
  },
};

export const filterValueMap = {
  en: {
    "Bathroom Sink Faucets": [
      "SKUColorFinishCode",
      "ProductInstallationType",
      "HandleStyle",
      "NumberOfHoles",
    ],

    "Bathroom Sinks": [
      "SKUColorFinishCode",
      "ProductMaterial",
      "ProductOverallLengthMm",
      "ProductOverallWidthMm",
      "ProductInstallationType",
      "ProductShape",
    ],

    Toilets: [
      "ProductNewProduct",
      "SKUColorFinishCode",
      "toilet_type",
      "LitersPerFlush",
      "BowlShape",
    ],

    "Toilet Seats": [
      "ProductNewProduct",
      "SKUColorFinishCode",
      "BowlShape",
      "NightLight",
      "BidetFunctionality",
    ],

    Bathing: [
      "SKUColorFinishCode",
      "ProductMaterial",
      "ProductInstallationType",
    ],

    Bidets: ["SKUColorFinishCode"],

    "Bidet Faucets": ["SKUColorFinishCode"],

    "Bathroom Accessories": ["SKUColorFinishCode", "ProductProductType"],

    "Bathroom Furniture": ["SKUColorFinishCode", "ProductProductType"],

    "Bath Faucets": [
      "SKUColorFinishCode",
      "HandleStyle",
      "ProductInstallationType",
    ],

    "Bath Spouts": ["SKUColorFinishCode"],

    Showerheads: [
      "SKUColorFinishCode",
      "ProductLitersPerMinute",
      "SprayType",
      "ProductShape",
    ],

    "Shower Faucets": [
      "SKUColorFinishCode",
      "SprayType",
      "NumberOfHoles",
      "HandleStyle",
    ],

    Handshowers: ["SKUColorFinishCode", "ProductLitersPerMinute", "SprayType"],

    Rainheads: ["SKUColorFinishCode", "ProductLitersPerMinute", "ProductShape"],

    "Body Sprays": [],

    Columns: ["SKUColorFinishCode"],

    "Shower Valves": [],

    "Shower Valve Trim": ["SKUColorFinishCode", "NumberOfHoles", "HandleStyle"],

    "Bath and Shower Fittings": ["SKUColorFinishCode", "ProductProductType"],

    "Shower Enclosures": ["SKUColorFinishCode", "ProductBrandNameDisplay"],

    "Commercial Faucets": ["SKUColorFinishCode"],

    "Commercial Urinals": [
      "SKUColorFinishCode",
      "ProductProductType",
      "ProductInstallationType",
      "LitersPerFlush",
    ],

    "Commercial Toilets": [
      "SKUColorFinishCode",
      "ProductInstallationType",
      "ProductLitersPerMinute",
    ],

    "Commercial Flushometers": [
      "SKUColorFinishCode",
      "ProductProductType",
      "ProductLitersPerMinute",
    ],

    "Kitchen Faucets": [
      "ProductNewProduct",
      "SKUColorFinishCode",
      "ProductNumberofHandles",
      "TouchlessFaucet",
    ],

    "Kitchen Sinks": [
      "SKUColorFinishCode",
      "ProductMaterial",
      "ProductInstallationType",
    ],

    "Kitchen Accessories": ["SKUColorFinishCode", "ProductProductType"],
  },
  vn: {
    "Grifería de Lavabo": [
      "SKUColorFinishCode",
      "ProductInstallationType",
      "HandleStyle",
      "NumberOfHoles",
    ],

    Lavabos: [
      "SKUColorFinishCode",
      "ProductMaterial",
      "ProductOverallLengthMm",
      "ProductOverallWidthMm",
      "ProductInstallationType",
      "ProductShape",
    ],

    Sanitarios: [
      "ProductNewProduct",
      "SKUColorFinishCode",
      "toilet_type",
      "LitersPerFlush",
      "BowlShape",
    ],

    "Asiento para Sanitarios": [
      "ProductNewProduct",
      "SKUColorFinishCode",
      "BowlShape",
      "NightLight",
      "BidetFunctionality",
    ],

    Bañeras: [
      "SKUColorFinishCode",
      "ProductMaterial",
      "ProductInstallationType",
    ],

    Bidés: ["SKUColorFinishCode"],

    "Grifería de Bidé": ["SKUColorFinishCode"],

    "Accesorios de Baño": ["SKUColorFinishCode", "ProductProductType"],

    "Muebles de Baño": ["SKUColorFinishCode", "ProductProductType"],

    "Grifería de Baño": [
      "SKUColorFinishCode",
      "HandleStyle",
      "ProductInstallationType",
    ],

    "Griferías de Bañera": ["SKUColorFinishCode"],

    "Cabezas de ducha": [
      "SKUColorFinishCode",
      "ProductLitersPerMinute",
      "SprayType",
      "ProductShape",
    ],

    "Grifería de Ducha": [
      "SKUColorFinishCode",
      "SprayType",
      "NumberOfHoles",
      "HandleStyle",
    ],

    "Duchas de mano": [
      "SKUColorFinishCode",
      "ProductLitersPerMinute",
      "SprayType",
    ],

    "Cabezas de Lluvia": [
      "SKUColorFinishCode",
      "ProductLitersPerMinute",
      "ProductShape",
    ],

    Rociadores: [],

    Columnas: ["SKUColorFinishCode"],

    "Válvulas de Ducha": [],

    "Accesorios de Baño y Ducha": ["SKUColorFinishCode", "ProductProductType"],

    "Manerales de Ducha": [
      "SKUColorFinishCode",
      "NumberOfHoles",
      "HandleStyle",
    ],

    "Recubrimientos para Ducha": [
      "SKUColorFinishCode",
      "ProductBrandNameDisplay",
    ],

    "Grifería Institucional": ["SKUColorFinishCode"],

    "Urinarios Institucionales": [
      "SKUColorFinishCode",
      "ProductProductType",
      "ProductInstallationType",
      "LitersPerFlush",
    ],

    "Sanitarios Institucionales": [
      "SKUColorFinishCode",
      "ProductInstallationType",
      "LitersPerFlush",
    ],

    "Fluxómetros Institucionales": [
      "SKUColorFinishCode",
      "ProductProductType",
      "ProductLitersPerMinute",
    ],

    "Grifería de Cocina": [
      "ProductNewProduct",
      "SKUColorFinishCode",
      "ProductNumberofHandles",
      "TouchlessFaucet",
    ],

    "Fregaderos de cocina": [
      "SKUColorFinishCode",
      "ProductMaterial",
      "ProductInstallationType",
    ],

    "Accesorios de Cocina": ["SKUColorFinishCode", "ProductProductType"],
  },
};

export const formatRedirectionUrl = (
  urlName,
  pageType,
  searchValue,
  currentPageValue
) => {
  if (pageType === "search") {
    const params = new URLSearchParams(window.location.search);
    const { type = "products" } = Object.fromEntries(params.entries());

    return `results/Category/${urlName.replace(
      / /g,
      "+"
    )}?type=${type}&search=${searchValue}${
      currentPageValue ? `&currentPage=${currentPageValue}` : ``
    }`;
  }
  return `results/Category/${urlName.replace(
    / /g,
    "+"
  )}?type=${pageType}&search=${searchValue}${
    currentPageValue ? `&currentPage=${currentPageValue}` : ``
  }`;
};

export const toValueCountArray = (
  arr = [],
  facetKey = "",
  colorSwatchLabels = {}
) => {
  const result = [];
  for (let i = 0; i < arr.length; i += 2) {
    const value = arr[i].replace(/&amp;/g, "and");
    const count = arr[i + 1];

    // Base object
    const option = { value, count };

    if (facetKey === "ColorFinish_s") {
      option.name = colorSwatchLabels?.[value] ?? value;
    }

    result.push(option);
  }
  return result;
};

const buildPriceRangeOptions = (rangeFacet = {}, labelPrefix = "") => {
  const { counts = [], gap = 0 } = rangeFacet;

  const options = [];

  for (let i = 0; i < counts.length; i += 2) {
    const start = Number(counts[i]);
    const count = counts[i + 1];

    if (!count || count <= 0) continue;

    const rangeStart = start - 1; // to make 1 → 0
    const rangeEnd = start + gap - 1;

    options.push({
      label: `${rangeStart} - ${rangeEnd}`,
      value: `${rangeStart}-${rangeEnd}`,
      count,
    });
  }

  return options;
};

const ignoredFacetKeys = [
  "product_s",
  "article_s",
  "spec_s",
  "Price_Range",
  "ProductCategory_s",
];

export const buildFacetObjectFromLabelsAndFields = (
  facetLabels = {},
  facetFields = {},
  colorSwatchLabels = {},
  facetRanges = {}
) => {
  ignoredFacetKeys.forEach(key => delete facetFields[key]);
  const mergedSource = {
    // Override GST facet values from ranges (if present)
    ...(facetRanges?.[ALLOWED_PRICE_FACET]
      ? { [ALLOWED_PRICE_FACET]: facetRanges[ALLOWED_PRICE_FACET] }
      : {}),
    ...facetFields,
  };

  return Object.entries(mergedSource)
    .filter(([facetKey]) => {
      if (!facetKey.startsWith("priceList.GST.finalPrice_d.")) return true;
      return facetKey === ALLOWED_PRICE_FACET;
    })
    .reduce((acc, [facetKey, rawValues]) => {
      const label = facetLabels[facetKey] ?? facetKey;

      acc[label] = {
        field: facetKey,
        options:
          facetKey === ALLOWED_PRICE_FACET
            ? buildPriceRangeOptions(rawValues)
            : toValueCountArray(rawValues, facetKey, colorSwatchLabels),
      };

      return acc;
    }, {});
};

export const buildTaggedFilter = obj => {
  const [[field, value]] = Object.entries(obj);
  return `{!tag="${field}"}${field}:("${value}")`;
};

export const buildFqParams = (selectedFilters = {}, locale = "en") => {
  locale = locale === "default" ? "en" : locale === "vn" ? "vi" : locale;
  const fq = [`language_s:${locale}`];

  Object.entries(selectedFilters).forEach(([field, values]) => {
    // if (!field || !Array.isArray(values) || values.length === 0) return

    // const cleanedValues = values.filter(v => v != null && v !== "")

    // if (cleanedValues.length === 0) return

    // const isRangeFacet = cleanedValues.every(
    //   v => typeof v === "string" && v.includes(" TO ")
    // )

    if (field === "priceList.GST.finalPrice_d") {
      fq.push(`{!tag="${field}"}${field}:([${values}])`);
    } else {
      fq.push(`{!tag="${field}"}${field}:("${values}")`);
    }

    // if (isRangeFacet) {
    //   // discountedPriceStartingAt.GST_d:([500 TO 1000] OR [1000 TO 1500])
    //   const rangeQuery = cleanedValues.map(v => `[${v}]`).join(" OR ")

    //   fq.push(`{!tag="${field}"}${field}:(${rangeQuery})`)
    // } else {
    //   const valueQuery = cleanedValues.map(v => `"${v}"`).join(" OR ")
    //   fq.push(`{!tag="${field}"}${field}:(${valueQuery})`)
    // }
  });

  return fq;
};

export const getFirstEntry = (obj = {}) => {
  const entries = Object.entries(obj);
  return entries.length ? entries[0] : [];
};

export const toSolrRange = rangeStr => {
  if (!rangeStr) return "";

  const [start, end] = rangeStr.split("-");
  return [`${Number(start)} TO ${Number(end)}`];
};

export const PLPModalImageFormatter = selectedImageResource => {
  if (selectedImageResource) {
    return selectedImageResource;
  } else {
    return "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
  }
};

export const imageURLWithPresetConfigPLP = (assetId = "") => {
  return `https://kohler.scene7.com/is/image/PAWEB/Category_Template?$GridResults$&$gradient_src=PAWEB%2Forganic%2Dgradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is{PAWEB%2F${assetId}}&defaultImage=force_error_state`;
};

export const getColorSwatchesPlpModal = data => {
  const color = data?.map(colorSwatches => {
    const swatchSrc = colorSwatches.split("|")[1];
    const styleName = colorSwatches.split("|")[0];
    const swatchName = colorSwatches.split("|")[1];
    return {
      styleName: styleName !== "N/A" ? styleName : "N/A",
      swatchName: swatchName !== "N/A" ? swatchName : "N/A",
      src: `https://kohler.scene7.com/is/image/PAWEB/${swatchSrc}`,
    };
  });
  return color;
};

export const imageURLWithPresetConfigQuickView = (assetId = "") => {
  return `https://kohler.scene7.com/is/image/PAWEB/Category_Template?$QuickView$&$gradient_src=PAWEB%2Forganic%2Dgradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is{PAWEB%2F${assetId}}&defaultImage=force_error_state`;
};
